export default "__VITE_ASSET__DFBynH6d__"